import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import Mosqueimg from "../../assets/audio/images/mosqueaudio.jpg";
import NavbarAll from "../NavbarAll/NavbarAllFiles";
import CustomAudioPlayer from "../BayanList/CustomAudioPlayer";
import "../BayanList/BayanListPage.css";

const BayanPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [bayan, setBayan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const websiteUrl = "https://www.zakariamasjid.com";
  const authorName = "مولانا محمد عابد صاحب";

  useEffect(() => {
    const fetchBayan = async () => {
      const searchParams = new URLSearchParams(location.search);
      const fallbackBayan = {
        title: searchParams.get("title") || "Shared Bayan",
        date: searchParams.get("date") || "",
        downloadURL: searchParams.get("audio") || "",
      };

      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/get-recording/${id}`);
        setBayan(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching bayan:', err);
        if (fallbackBayan.downloadURL) {
          setBayan(fallbackBayan);
          setError(null);
        } else {
          setError('Failed to load bayan');
        }
        setLoading(false);
      }
    };

    fetchBayan();
  }, [id, location.search]);

  return (
    <>
      <Helmet>
        <title>{bayan?.title ? `${bayan.title} | Bayan` : "Shared Bayan | Zakaria Masjid"}</title>
        <meta
          name="description"
          content={
            bayan?.title
              ? `${bayan.title} - ${authorName}. Listen to this bayan on Zakaria Masjid.`
              : `Listen to this bayan by ${authorName} on Zakaria Masjid.`
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Zakaria Masjid" />
        <meta property="og:title" content={bayan?.title || "Shared Bayan"} />
        <meta
          property="og:description"
          content={`${authorName}${bayan?.date ? ` | ${bayan.date}` : ""}`}
        />
        <meta property="og:url" content={`${websiteUrl}${location.pathname}${location.search}`} />
        <meta property="og:image" content={`${websiteUrl}/logo512.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={bayan?.title || "Shared Bayan"} />
        <meta
          name="twitter:description"
          content={`${authorName}${bayan?.date ? ` | ${bayan.date}` : ""}`}
        />
        <meta name="twitter:image" content={`${websiteUrl}/logo512.png`} />
      </Helmet>

      {loading && (
        <div className="bayan-loader-overlay">
          <div className="bayan-spinner" />
          <p>Loading Bayan...</p>
        </div>
      )}

      <NavbarAll />

      <section>
        <div className="w-100 pt-80 black-layer pb-70 opc65 position-relative bayan-hero-wrap">
          <div className="fixed-bg" style={{ backgroundImage: `url(${Mosqueimg})` }} />
          <div className="container">
            <div className="page-title-wrap text-center w-100">
              <div className="page-title-inner d-inline-block bayan-hero-card">
                <p className="bayan-hero-kicker">Zakaria Masjid Bayanats</p>
                <h1 className="mb-0">Shared Bayan</h1>
                <p className="bayan-hero-desc">Listen to this bayan shared with you.</p>
                <ol className="breadcrumb mb-0 bayan-hero-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/" title="Home">
                      Masjid - Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/fridaybayan" title="Friday Bayan">
                      Bayan List
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Now Playing</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="w-100 pt-120 pb-120 position-relative">
          <div className="container">
            {error ? (
              <div className="bayan-empty-state">
                <h4>Unable to load this bayan</h4>
                <p>{error}</p>
              </div>
            ) : (
              bayan && (
                <div className="bayan-card">
                  <div className="bayan-card-head">
                    <div>
                      <p className="bayan-label">Topic</p>
                      <h4>{bayan.title || "Shared Bayan"}</h4>
                    </div>
                    <div className="bayan-date-badge">{bayan.date || "Shared Link"}</div>
                  </div>
                  <CustomAudioPlayer src={bayan.downloadURL} />
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default BayanPage;
